import { toast } from 'react-toastify';
import React,{ useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FullPageLoader from '@src/common/FullPageLoader';
import { NavLink, useSearchParams, useNavigate, useParams } from 'react-router-dom';
import secureStorage from '@src/config/encrypt';
import { getLeadDetails, saveInsurance, updateDocumentStatus, updateFormConfig } from '@src/store/slices/insurance';
import { getMasterConfig, addDocumentWeb, getReporteeID } from '@src/store/slices/common';
import { APP_TYPE_AGENCY, STATUS_CODES, WITH_RULE_ENGINE } from '@src/config/constant';
import InsuranceService from '@src/services/InsuranceService';
import AddApplicationThankPopup from '../AddApplicationThankPopup';
import { isMobile } from "react-device-detect";
import { getFormFields, getLeadDocumentList,setNewMMVlist, docs_upload, getDocumentListing, getStateList, getCityList} from '@store/slices/commonId';
import Addons from './Addons';
import Quotes from './Quotes';
import Docs from './Docs';
import Create from './CreateApplication';
import { getaddonListID, insurerListID,uploadAndReadDocument} from "@src/store/slices/insurance";
import { MOVE_TO_BASIC_IDS } from '@src/config/constant';
import * as HELPER from "@src/config/helper";
import { FIELD_TYPE, CURRENCY_SYMBOL,LEAD_STATUS, POLICY_HOLDER, CREATE_PAGE_INDEX, IS_ACC_TOGGLE, ROLE, QUOTATION_SHARE_TYPE, SAME_AS_KTP,LEAD_TYPE, UPLOAD_TYPE,VEHICLE_CONDITION,OCR_NPWP_ID, OCR_KTP_ID, OCR_STNK_ID } from '@src/config/id/constant'; 
import { getInsuranceDetail } from '@store/slices/insuranceId';
import UploadImagesPopup from './UploadImagesPopup';
import { fetchPermanentLocality } from './functions/common.fn';
import { getSavedDiscount, uniqueAddonDetail } from './functions/addon.fn';
import { buildDocsDraftPayload, isQuotationSharedLead, shouldResumeAtQuote } from './functions/docsDraft.fn';
import DocumentResubmission from './resubmission/ResubmitDocs';
import { useLanguage } from '@src/context/LanguageContext';
import QuotesMobile from './QuotesMobile';
import WaitPopUpModal from '@src/common/WaitPopUpModal';


export default function CreateApplicationId(props: any) {

    const [page, setPage] = useState<number>(1)
    const [loading, setLoading] = useState(false)
    const [sectionList, setSectionList] = useState<any>([])
    const [masterData, setMasterData] = useState<any>({})
    const [documentList, setDocumentList] = useState<Array<any>>([])
    const [showThankyouPopup, setShowThankyouPopup] = useState(false)
    const [leadId, setLeadId] = useState<any>(null)
    const [isEdit, setIsEdit] = useState(false);
    const [deletedDocs, setDeletedDocs] = useState<any[]>([]);
    const [searchParams, setSearchParams] = useSearchParams()
    const subRoute: any = searchParams.get('step');
    const dispatch: any = useDispatch()
    const insuranceState = useSelector((state: any) => state.insurance)
    const commonState = useSelector((state: any) => state.common)
    const commonIdState = useSelector((state: any) => state.commonId)
    const navigate: any = useNavigate()
    const queryParams = useParams();
    const resubmissionLeadId = queryParams.id
    // const[updateMakeYear, SetUpdateMakeYear] = useState(false);

    const [basicAddons, setBasicAddons] = useState<any>([]);
    const [specialAddons, setSpecialAddons] = useState<any>([]);
    const [addOnQuesAns, setAddOnQuesAns] = useState<any>([]);
    const [documentFormObj, setDocumentFormObj] = useState<any>([]);
    const [addonState, setAddonState] = useState<any>({});
    const [requestData, setRequestData] = useState<any>({});
    const [imageUploadState, setImageUploadState] = useState<any>({
        uploaded: 0,
        total:0,
        show:false
    })
    const [discountType, setDiscountType] = useState<any>('');
    const [customerDiscount, setCustomerDiscount] = useState('');
    const [addonError, setAddonError] = useState<any>({});
    const [leadDetailData,setLeadDetailData] = useState<any>({});
    // set by "Continue Application" on the listing: resume a shared-quotation lead at the Docs step
    const continueToDocsRef = useRef<boolean>(!!secureStorage.getItem('goToDocs'));
    const [createloading, setCreateloading] = useState(false)
    const [isShowResubmitBtn, setIsShowResubmitBtn] = useState(false);
    const [isWaitingForDocumentRead, setIsWaitingForDocumentRead] = useState(false);
    const {translations} = useLanguage();
    const [insuranceValues, setInsuranceValues] = useState<any>([]);   

    // Draft save of the Docs step: when the agent leaves Docs without submitting, whatever is filled
    // (plus discount / selected quote) is stored on the lead, so the next "Continue Application" is prefilled.
    const draftDirtyRef = useRef<boolean>(false);      // user changed something on Docs (or came from Quote "Continue")
    const draftTimerRef = useRef<any>(null);
    const lastDraftRef = useRef<string>('');           // last saved payload, avoids duplicate calls
    const draftSubmittedRef = useRef<boolean>(false);  // final submit started -> never draft-save again
    const saveDraftRef = useRef<any>(null);
    const busyRef = useRef<boolean>(false);
    const prevSubRouteRef = useRef<any>(subRoute);
    const DRAFT_AUTOSAVE_DELAY = 3000;
    const docsBaselineRef = useRef<boolean>(false);         // Docs prefilled from the lead -> compare against it
    const docsBaselinePendingRef = useRef<boolean>(false);
    const isDocsStep = (step: any) => step === 'docs' || step === 'documents';

    let { user_data } = secureStorage.getItem("authAgentUserInfo") || {};
    const hiddenApplicationTypeFields = ["application_type", "rule_engine"];
    const getEffectiveRuleEngine = (ruleEngine?: any) => {
        if (ruleEngine !== null && ruleEngine !== "") {
            return ruleEngine;
        }

        return user_data?.role_id === ROLE.AGENT ? WITH_RULE_ENGINE : ruleEngine;
    };

    const getInsuranceTypeValues = (data: any) => {
        if (Array.isArray(data?.multi_year) && data?.multi_year?.length) {
            return data.multi_year
                .map((item: any) => item?.insurance_type)
                .filter((value: any) => value !== undefined && value !== null && value !== "");
        }

        if (Array.isArray(data?.insurance_type)) {
            return data.insurance_type
                .filter((value: any) => value !== undefined && value !== null && value !== "");
        }

        if (data?.insurance_type !== undefined && data?.insurance_type !== null && data?.insurance_type !== "") {
            return [data.insurance_type];
        }

        return [];
    };

    const normalizeLeadInsuranceTypes = (data: any) => {
        const insuranceTypeValues = getInsuranceTypeValues(data);

        if (!insuranceTypeValues.length) {
            return data;
        }

        return {
            ...data,
            insurance_type: insuranceTypeValues,
        };
    };

    const getLeadDetailsPayload = (response: any) => {
        if (response?.data && typeof response.data === "object" && !Array.isArray(response.data)) {
            return response.data;
        }

        return response;
    };

    const fetchFormConfig = async (masterData: any) => {
        const payload={"formType":"lead"}
        const result:any = await getFormFields(payload) 
        if (result?.status === 200 && result?.data?.insuranceFormFields?.length) {
            updateSectionList(result?.data?.insuranceFormFields, masterData)
            setLoading(false);

        }
    }

    const updateSectionList = async (sectionList: any, masterData: any) => {
        const item = secureStorage.getItem('vehicle_type');

        if (sectionList?.length) {
            let updatedList = JSON.parse(JSON.stringify(sectionList))
            updatedList.forEach((sectionItem: any) => {
                sectionItem?.blocks?.forEach((blockItem: any) => {
                    blockItem?.fields?.forEach((fieldItem: any) => {
                        if(fieldItem?.name==='vehicle_category' && item){
                            const options = commonState?.common?.vehicle_category;
                            const option = options?.find((option:any) => option?.value === item?.category_id)
                            fieldItem['value'] = option
                        }
                        if(fieldItem?.name==='vehicle_type' && item){
                            const options= commonState?.common?.vehicle_type?.filter((option:any) => option?.category_id === item?.category_id)
                            fieldItem['dynamicOptions'] = options
                            fieldItem['value'] = item
                        }
                    });
                });
            });
            updatedList = await showAgentNameField(updatedList)
            setSectionList([...updatedList])
            const leadId = secureStorage.getItem('lead_id');
            if(leadId) setLeadId(leadId)
            dispatch(updateFormConfig(updatedList || []));
        } else {
            navigate('/create-insurance-policy?step=document_upload')
            toast.error("Error in fetching form config")
        }
    }

    const fetchDocumentList = () => {
        dispatch(getDocumentListing({
            lead_id: resubmissionLeadId
        })).then((res: any) => {
            if (resubmissionLeadId) {
                getResubmissionDocs(res?.data)
            }
        }).catch(() => {
            setLoading(false)
        })
    }

    const fetchMasterConfig = async () => {
        setLoading(true);
        if (!commonState?.common || !Object.keys(commonState?.common)?.length) {
            dispatch(getMasterConfig()).then((resp: any) => {
                if (resp.status === STATUS_CODES['success']) {
                    setMasterData(resp.data);
                    fetchFormConfig(resp.data);
                    setLoading(false);
                }
            });
        }
        else {
            setMasterData(commonState.common);
            fetchFormConfig(commonState.common);
        }

    }

    const handleNavLinkRouting = (page: any) => {
        return
    }

    const getResubmissionDocs = async (docList: any) => {
        const leadData = await dispatch(getLeadDetails({ apptype: APP_TYPE_AGENCY, leadId: resubmissionLeadId }))
        const resubmitDocs = leadData?.documents?.filter((e: any) => e?.is_resubmit)
        const otherDocs = leadData?.documents?.filter((e: any) => !e?.is_resubmit)

        const keysToUpdate = ['documents', 'partner_id', 'rule_engine',
            'application_type_id', 'insurance_type', 'make', 'make_name', 'model', 'model_name',
            'version', 'version_name', 'lead_id']

        let updatedInsuranceState: any = {}
        for (let key of keysToUpdate) {
            if (leadData?.[key]) {
                if (key === 'application_type_id') {
                    updatedInsuranceState['application_type'] = leadData[key]
                } else updatedInsuranceState[key] = leadData[key]
            }
        }

        // if (!resubmitDocs?.length) {
        //     navigate('/create-insurance-policy')
        //     setDocumentList(docList)
        //     setLoading(false)
        //     dispatch(saveInsurance({}))
        //     return
        // }

        dispatch(saveInsurance({ ...insuranceState?.createInsurance, ...updatedInsuranceState }))

        let updatedDocumentList = JSON.parse(JSON.stringify(docList))
        let isResubmit = false
        for (let doc of updatedDocumentList) {
            let findDOc = resubmitDocs?.find((el: any) => el.id === doc?.value)
            if (findDOc) {
                doc['src'] = findDOc?.path?.map((e: any) => ({ src: e.src, id: e.id }))
                doc['is_resubmit'] = true
                doc['comment'] = findDOc?.comment
                doc['is_file_resubmit'] = true
                isResubmit = true
            }
            let findOtherDoc = otherDocs?.find((el: any) => el.id === doc?.value);
            if (findOtherDoc) {
                doc['src'] = findOtherDoc?.path?.map((e: any) => ({ src: e.src, id: e.id }))
                doc['is_resubmit'] = false
                doc['is_file_resubmit'] = false
            }

            if (doc?.child?.length) {
                let child = doc.child
                for (let subDoc of child) {
                    let findSubDoc = resubmitDocs?.find((el: any) => el.id === subDoc?.value)
                    let findSubOtherDoc = otherDocs?.find((el: any) => el.id === subDoc?.value)

                    if (findSubDoc) {
                        subDoc['src'] = findSubDoc?.path?.map((e: any) => ({ src: e.src, id: e.id }))
                        subDoc['is_resubmit'] = true
                        subDoc['comment'] = findSubDoc?.comment
                        subDoc['is_file_resubmit'] = true
                        isResubmit = true
                    }
                    if (findSubOtherDoc) {
                        subDoc['src'] = findSubOtherDoc?.path?.map((e: any) => ({ src: e.src, id: e.id }))
                        subDoc['is_resubmit'] = false
                        subDoc['is_file_resubmit'] = false

            
                    }
                }
            }
        }

        setIsShowResubmitBtn(isResubmit)
        setDocumentList(updatedDocumentList)
        setLoading(false)
        setPage(4)
    }

    useEffect(() => {
        secureStorage.removeItem('goToDocs'); // one-shot flag, already captured in continueToDocsRef
        setLoading(true)
        if(!resubmissionLeadId){
            fetchMasterConfig()
        }
        if(resubmissionLeadId){
            fetchDocumentList()
        }
    }, [])

    useEffect(() => {
        if (!subRoute) {
            setSearchParams({ step: 'vehicle' })
        }
    }, [subRoute])

    useEffect(() => {
        if (resubmissionLeadId) {
            setSearchParams({ step: 'resubmission' })
        }
        // else{
        //     setSearchParams({ step: 'vehicle' })
        // }
    }, [resubmissionLeadId, sectionList])


    const handleSkip = () => {
        fetchInsurerList([])
        setSearchParams({step:'quote'})
        setPage(3)
    }
    const fetchAddons = async (data:Record<string,any>,list:boolean=false)=>{
        const insuranceTypeList = getInsuranceTypeValues(data);
        const multi_year = insuranceTypeList.map((item: number) => ({ insurance_type: item}));
        const payload: any = {
            //insurance_type: Array.isArray(data?.insurance_type) ? data.insurance_type[0] : data?.insurance_type,
            vehicle_type: data?.vehicle_type,
            plate_area_type: data?.plate_area_type,
            make_year: data?.make_year,
            total_fmv: data?.total_fmv,
            tenure: data?.tenure,
            multi_year,
            rule_engine: data?.rule_engine,
            vehicle_condition: data?.vehicle_condition,
            vehicle_usage: data?.vehicle_usage
        };
        
        if(data?.insurer_id) payload.insurer_id = data?.insurer_id

        const response = await dispatch(getaddonListID(payload));
        if(response?.status!==200) return

        const apiBasic = response?.data?.basic || [];
        const apiSpecial = response?.data?.special || [];

        // id = 8 remove from special
        const specialWithout8 = apiSpecial.filter((item: any) => !MOVE_TO_BASIC_IDS.includes(item.id));
        const addon8 = apiSpecial.find((item: any) => Array.isArray(MOVE_TO_BASIC_IDS) ? MOVE_TO_BASIC_IDS.includes(item.id) : item.id === MOVE_TO_BASIC_IDS);
        setBasicAddons(addon8 ? [...apiBasic, addon8] : apiBasic);
        setSpecialAddons(specialWithout8);

        // Prepare Q&A data for Get Help modal
        const helpData = prepareHelpData(response.data);
        setAddOnQuesAns(helpData);

        // Set default coverage if API provides default sum insured
        const defaults: any = {};
        response?.data?.basic?.forEach((item: any) => {
            if (item.default_sum_insured) {
                defaults[item.id] = {
                    value: item.default_sum_insured,
                    label: item.default_sum_insured
                };
            }
        });
        if(list){
         return addon8 ? [...apiBasic, addon8] : apiBasic
        }else{
            return response?.data
        }
        
    }
    const fetchInsurerList = async(addon_detail: any,data:any=requestData) => {
        setLoading(true)
        let response: any = null;
        const insuranceTypeList = getInsuranceTypeValues(data);
        const multi_year = insuranceTypeList.map((item: number) => ({ insurance_type: item}));
        const payload = {
            sort_by: data?.sort_by || "RC",
            vehicle_usage: data?.vehicle_usage,
            //insurance_type: data?.insurance_type[0],
            vehicle_type: data?.vehicle_type,
            plate_area_type: data?.plate_area_type,
            make_year: data?.make_year,
            car_fmv: data?.car_fmv,
            acc_price: data?.acc_price,
            total_fmv: data?.total_fmv,
            make: data?.make || commonIdState?.newMMVlist?.make_id?.value,
            vehicle_condition: data?.vehicle_condition,
            addon_detail,
            rule_engine: data?.rule_engine,
            insurance_starting_date: data?.insurance_starting_date?.split('T')[0],
            customer_discount_per: data?.customer_discount_per || 0,
            customer_discount: data?.customer_discount || 0,
            tenure: data?.tenure,
            multi_year 
        };

        const res: any = await dispatch(insurerListID(payload));
        if(res.status===200){
            response = res.data;
             const goToQuote = secureStorage.getItem('goToQuote');
 if (goToQuote) {
                navigate('/create-insurance-policy?step=quote');
            }        }
        setLoading(false)
        return response
    }

    const prepareHelpData = (data: any) => {
        const basic = data?.basic?.map((item: any) => ({
            id: item.id,
            question: item.question,
            description: item.description,
            category: "Basic"
        })) || [];

        const special = data?.special?.map((item: any) => ({
            id: item.id,
            question: item.question,
            description: item.description,
            category: "Special"
        })) || [];

        return [...basic, ...special];
    };

    // several doc-list calls can be in flight (effect below + Docs prefill in fillForm);
    // only the latest may set the form, else an empty list overwrites the prefilled Docs values
    const docListReqRef = useRef<number>(0);
    const leadDocList = async ()=>{
        if (!requestData?.vehicle_condition || !requestData?.policy_holder) return; 
        let params = {
            vehicle_condition: requestData.vehicle_condition,
            policy_holder: requestData.policy_holder,
            insurer_id: requestData.insurer_id
        }
        const reqNo = ++docListReqRef.current;
        const res = await dispatch(getLeadDocumentList(params))
        if(res?.status!==200) return
        if (reqNo !== docListReqRef.current) return res; // a newer call owns the form
        setDocumentFormObj(res.data.document_list);
        return res
    }

    useEffect(() => {
        leadDocList()
    }, [ requestData?.vehicle_condition,  requestData?.policy_holder,requestData.insurer_id]);

    const mergeFieldObject = () => {
        if (!documentFormObj?.length) return [];
        const mergedFields = documentFormObj.flatMap((item: any) => item.fields || []);
        return mergedFields;
    }

    const formatOcrPlateNumber = (plateNumber: string = "") => {
        const trimmedPlateNumber = plateNumber?.trim();
        const plateMatch = trimmedPlateNumber?.match(/^([A-Za-z]+)\s*(.+)$/);
        if (!plateMatch) return trimmedPlateNumber;

        return `${plateMatch[1]} ${plateMatch[2]}`;
    }

    const getSectionFields = (index: number,data?:any) => {
        
    let fields: any =  index === CREATE_PAGE_INDEX.CREATE ? sectionList ?.[index]?.blocks?.[0]?.fields :mergeFieldObject();
    if(data) fields = index === CREATE_PAGE_INDEX.CREATE ? data ?.[index]?.blocks?.[0]?.fields :mergeFieldObject();

    fields = fields?.reduce((acc: any, row: any) => {
      if (!row?.name) return acc;

      let value =
        row.value instanceof Date
        ? row.value.toISOString()
        : typeof row.value === "object"
            ? row.value?.value
            : row.value;

        // strip currency formatting only for currency fields; free-text fields (e.g. acc_description) may legitimately contain "Rp"
        if(row?.type === FIELD_TYPE.CURRENCY && typeof value ==='string' && value?.includes(CURRENCY_SYMBOL)){
            value = HELPER.removeCurrencyFormattingId(value)
        }

        if (row?.name === 'plate_number' && typeof value === 'string') {
            value = value.replace(/\s+/g, '');
        }

      if (
        !value
      ) {
        return acc;
      }

      acc[row.name] = value;
      return acc;
    }, {});

    if (index === CREATE_PAGE_INDEX.CREATE) {
        fields.rule_engine = getEffectiveRuleEngine(fields.rule_engine);
    }

    return fields;
    };


  const hasFiles = (node: any): boolean => {
  if (!node) return false;

  if (node.uploaded_files && node.uploaded_files.length > 0) return true;

  if (node.child?.length) {
    return node.child.some(hasFiles);
  }

  return false;
};

const validatePolicyVehicleDoc = (doc: any): boolean => {
  const existingPolicyNode = doc.child.find(
    (c: any) => c.label === "Existing Policy"
  );

  const vehiclePhotosNode = doc.child.find(
    (c: any) => c.label === "Vehicle Photos"
  );

  const existingHasFile = hasFiles(existingPolicyNode);
  const vehicleHasFile = hasFiles(vehiclePhotosNode);

  //both selected (not allowed)
  if (existingHasFile && vehicleHasFile) return false;

  // Existing Policy case
  if (existingHasFile) return true;

  // Vehicle Photos case
  if (vehicleHasFile) {
    let allRequiredOk = true;

    const checkRequired = (node: any) => {
        if (node.is_required && !hasFiles(node)) {
      allRequiredOk = false;
      return;
    }
      node.child?.forEach(checkRequired);
  };

 checkRequired(vehiclePhotosNode);
  return allRequiredOk;
  }
  return false;
};


    
    const validateFields = (index: number) => {
      let isValid = true;

      const errorKeys: string[] = [];

      const skipKeys = new Set<string>();
      const updatedSec = structuredClone(sectionList);
      const getRequiredMessage = (item: any) =>
        item?.error_msg || (item?.label ? `${item.label} is required` : translations?.COMMON_MSG?.REQUIRED);

      if (CREATE_PAGE_INDEX?.CREATE === index) {
        const fields = updatedSec?.[index]?.blocks?.[0]?.fields || [];
        const existingErrors = fields
          .filter((field: any) => !(user_data?.role_id === ROLE.AGENT && hiddenApplicationTypeFields.includes(field?.name)))
          .map((e: any) => e.error_message)
          ?.filter(Boolean);
        if(existingErrors?.length > 0) return
        
        for (let i = 0; i < fields.length; i++) {
          const field = fields[i];

         if (user_data?.role_id === ROLE.AGENT && hiddenApplicationTypeFields.includes(field?.name)) {
            field.error_message = "";
            continue;
        }

          if (index === CREATE_PAGE_INDEX.CREATE) {
            if (field?.field_show) {
              const splitType = field.field_show.split("/");
              if (splitType.length > 1) {
                const item = fields?.find((e: any) => e.name === splitType[0]);
                const value = typeof item?.value === "object" ? item?.value?.value: item?.value;
                if (value != splitType[1]) {
                  skipKeys.add(field.name);
                }
              }
            }
          }

          // skip validation
          if (skipKeys.has(field.name)) {
            field.error_message = "";
            continue;
          }

          // normalize value
          const value =
            field.value instanceof Date
              ? field.value.toISOString()
              : typeof field.value === "object"
                ? field.value?.value
                : field.value;

          if (field.name === "insurance_type") {
            const tenureField = fields.find((item: any) => item.name === "tenure");
            const tenureValue = typeof tenureField?.value === "object"
              ? tenureField?.value?.value
              : tenureField?.value;
            const requiredYears = Math.max(1, Number(tenureValue) || 1);
            const hasInsuranceTypeForEveryYear = Array.from(
              { length: requiredYears },
              (_, yearIndex) => insuranceValues?.[yearIndex]
            ).every((selectedValue) =>
              selectedValue !== undefined && selectedValue !== null && selectedValue !== ""
            );

            field.error_message = hasInsuranceTypeForEveryYear ? "" : getRequiredMessage(field);
            if (!hasInsuranceTypeForEveryYear) {
              isValid = false;
              errorKeys.push(field.name);
            }
            continue;
          }

          //  required validation
          if (
            field.is_show &&
            field.is_required &&
            (value === undefined || value === null || value === "")
          ) {
            field.error_message = field.error_msg
            isValid = false;

            // error key
            errorKeys.push(field.name);
          } else {
            field.error_message = "";
          }
        }
        setSectionList(updatedSec);
      }

      if (CREATE_PAGE_INDEX?.DOC === index) {
        const updatedSectionItem = structuredClone(documentFormObj);
        for (let i = 0; i < updatedSectionItem.length; i++) {
          const docFields = updatedSectionItem[i]?.fields || [];
            const existingErrors = docFields.map((e: any) => e.error_message)?.filter(Boolean);
            if(existingErrors?.length > 0) {
                isValid = false;
            }
            if(updatedSectionItem[i].label === "Existing Policy or Vehicle Photos") {
                const isOk = validatePolicyVehicleDoc(updatedSectionItem[i]);

                if (!isOk) {
                    updatedSectionItem[i].error_message = translations?.CREATE_APP?.DOC_REQUIRED
                    isValid = false;
                } else {
                    updatedSectionItem[i].error_message = "";
                }
            }
            else if(updatedSectionItem[i].is_required &&  (!updatedSectionItem[i]?.uploaded_files || updatedSectionItem[i]?.uploaded_files?.length === 0)){
                updatedSectionItem[i].error_message =  getRequiredMessage(updatedSectionItem[i])
             isValid = false;
            }
            else{
          updatedSectionItem[i].error_message = ""
            }
          for (let j = 0; j < docFields.length; j++) {
            const field = docFields[j];
            if (field.error_msg && !field.error_message) {
              field.error_message = field.error_msg;
            }
            // 🔹 normalize value
            const value =
              field.value instanceof Date
                ? field.value.toISOString()
                : typeof field.value === "object"
                  ? field.value?.value
                  : field.value;

            const fieldName = String(field.name || '');
            const fieldLabel = String(field.label || '');
            const isPlateField = fieldName === 'plate_number' || fieldName === 'plate_no' || /plate\s*number/i.test(fieldLabel);

            if (isPlateField) {
                const plateValue = String(value || '').trim().toUpperCase();
                if (plateValue) {
                    const plateAreaList = commonState?.common?.plate_area || [];
                    const plateAreaLabel =
                        plateAreaList.find((row: any) => String(row.value) === String(requestData?.plate_area))?.label ||
                        (typeof requestData?.plate_area === 'string' ? requestData.plate_area : '');
                    const platePrefix = String(plateAreaLabel).trim().toUpperCase().split(/[-\s]+/)[0] || '';

                if (platePrefix && plateValue === platePrefix) {
                    field.error_message = getRequiredMessage(field);
                    isValid = false;
                    errorKeys.push(field.name);
                    continue;
                }

                // Fallback when prefix isn't resolved: block if value is letters-only (prefix without suffix)
                if (!platePrefix && /^[A-Z]+$/.test(plateValue)) {
                    field.error_message = getRequiredMessage(field);
                    isValid = false;
                    errorKeys.push(field.name);
                    continue;
                }

                // const vehicleConditionValueRaw = requestData?.vehicle_condition;
                // const vehicleConditionValue =
                //     typeof vehicleConditionValueRaw === 'object'
                //         ? vehicleConditionValueRaw?.value
                //         : vehicleConditionValueRaw;
                // const plateErrorMsg = translations.RuleEngineAgency?.PLATE_ERROR_MSG || translations.commonMsg?.loading;
                // const usedPattern = /^[A-Z]{1,2}\s?\d+(?:\s?[A-Za-z]+)?$/;

                // if (+vehicleConditionValue === VEHICLE_CONDITION.USED) {
                //     if (!plateValue || !usedPattern.test(plateValue)) {
                //         field.error_message = plateErrorMsg;
                //         isValid = false;
                //         errorKeys.push(field.name);
                //         continue;
                //     }
                // }
                // if (+vehicleConditionValue === VEHICLE_CONDITION.NEW) {
                //     if (!plateValue) {
                //         field.error_message = plateErrorMsg;
                //         isValid = false;
                //         errorKeys.push(field.name);
                //         continue;
                //     }
                // }
                if (!plateValue) {
                    field.error_message = getRequiredMessage(field);
                    isValid = false;
                    errorKeys.push(field.name);
                    continue;
                }
            }
            }

            // required validation
            if (
              field.is_show &&
              field.is_required &&
              (value === undefined || value === null || value === "")
            ) {
                if(field.name === "mobile"){
                    const trimmedValue = value?.toString().trim();
                    const CheckValid = /^8\d{7,12}$/.test(trimmedValue);
                    if(!CheckValid){
                        field.error_message = translations?.CREATE_APP?.MOBILE_ERR;
                        isValid = false;
                        errorKeys.push(field.name);
                    }
                }else{
                    field.error_message = getRequiredMessage(field);
                    isValid = false;
                    errorKeys.push(field.name);
                }
            } else {
                if(field.name === "mobile"){
                    const trimmedValue = value?.toString().trim();
                    const CheckValid = /^8\d{7,12}$/.test(trimmedValue);
                    if(!CheckValid){
                        field.error_message = translations?.CREATE_APP?.MOBILE_ERR;
                        isValid = false;
                        errorKeys.push(field.name);
                    } else {
                        field.error_message = "";
                    }
                }else{
                    field.error_message = "";
                }
            }
          }
        }
        setDocumentFormObj(updatedSectionItem);
      }
      return isValid;
    };


    const uploadAllNodes = async (
        node: any,
        lead_id: number,
        docUrls: any[],
        imageState: any
    ) => {
        if (node.uploaded_files?.length) {
            await uploadDocumentFiles(node, lead_id, docUrls, imageState);
        }

        if (node.child?.length) {
            for (const c of node.child) {
                await uploadAllNodes(c, lead_id, docUrls, imageState);
            }
        }
    };


    const handleSubmit = async (sectionIndex: number, addon_detail?: any) => {
        const isValid = validateFields(sectionIndex);
        let data = getSectionFields(sectionIndex);
        if(!isValid) return
        if(sectionIndex===CREATE_PAGE_INDEX.CREATE){
            data = {...requestData,...data};
            data.rule_engine = getEffectiveRuleEngine(data?.rule_engine);
            data.make = commonIdState?.newMMVlist?.make_id?.value;
            data.make_name = commonIdState?.newMMVlist?.make_id?.label;
            data.parent_model_id = commonIdState?.newMMVlist?.model_id?.value;
            data.parent_model_name = commonIdState?.newMMVlist?.model_id?.label;
            data.model = commonIdState?.newMMVlist?.version_id?.model;
            data.model_name = commonIdState?.newMMVlist?.version_id?.model_name;
            data.version = commonIdState?.newMMVlist?.version_id?.value;
            data.version_name = commonIdState?.newMMVlist?.version_id?.label;
            data.user_id = user_data?.id;
            data.role_id= user_data?.role_id;
            if(insuranceValues?.length >0){
               data.insurance_type = insuranceValues 
            }

            setRequestData(data);
            if(!leadId){
                fetchAddons(data)
                setPage(2);
            }
            setSearchParams({ step: 'addons' })
        }
        if (sectionIndex === CREATE_PAGE_INDEX.ADDONS) {
            const updatedData = structuredClone(requestData);
            const cleanedAddons = (addon_detail || []).filter( (item: any) => item?.id !== null && item?.id !== undefined);
            updatedData.addon_detail = cleanedAddons;
            setRequestData(updatedData);
            if(!leadId){
                setPage(3)
            }
            setSearchParams({ step: 'quote' })
        }
        if (sectionIndex === CREATE_PAGE_INDEX.QUOTES) {
            // discount / final quote changed -> store it with the Docs draft
            if (leadId) draftDirtyRef.current = true;
            if(!leadId){
                setPage(4)
            }
            setSearchParams({ step: 'docs' })

        }
        if (sectionIndex === CREATE_PAGE_INDEX.DOC) { 
        draftSubmittedRef.current = true;
        clearTimeout(draftTimerRef.current);
        try {
            const updatedPlateCheck = structuredClone(documentFormObj);
            let plateFieldRef: any = null;
            updatedPlateCheck.forEach((doc: any) => {
                doc?.fields?.forEach((field: any) => {
                    const name = String(field?.name || '');
                    const label = String(field?.label || '');
                    const isPlate =
                        name === 'plate_number' ||
                        name === 'plate_no' ||
                        /plate/i.test(name) ||
                        /plate\s*number/i.test(label);
                    if (isPlate) plateFieldRef = field;
                });
            });

            if (plateFieldRef) {
                const plateValue = String(plateFieldRef?.value || '').trim().toUpperCase();
                if (plateValue) {
                    const plateAreaList = commonState?.common?.plate_area || [];
                    const plateAreaLabel =
                        plateAreaList.find((row: any) => String(row.value) === String(requestData?.plate_area))?.label ||
                        (typeof requestData?.plate_area === 'string' ? requestData.plate_area : '');
                    const platePrefix = String(plateAreaLabel).trim().toUpperCase().split(/[-\s]+/)[0] || '';
                    const invalidPlate = (platePrefix && plateValue === platePrefix) || (!platePrefix && /^[A-Z]+$/.test(plateValue));

                    if (invalidPlate) {
                        plateFieldRef.error_message = 'Please enter plate number';
                        setDocumentFormObj(updatedPlateCheck);
                        draftSubmittedRef.current = false;
                        return;
                    }
                }
            }

            delete requestData.old_plate_area
            delete requestData.vehicle
            delete requestData.version_id
            delete requestData.sort_by
            delete requestData.old_insurer_id

            // Branch picked on the Docs form (data) must win over the saved/stale value in requestData,
            // otherwise in edit mode the old branch (e.g. Malang) is stored even after selecting a new one (e.g. Bali).
            const insurerBranchId:number = data?.insurer_branch_id || requestData?.insurer_branch_id
            
            const payload = {
                ...requestData,
                user_id: user_data?.id,
                role_id: user_data?.role_id,
                ...data,
                per_sameas_cur: data?.per_sameas_cur ? IS_ACC_TOGGLE.INACTIVE : IS_ACC_TOGGLE.ACTIVE,
                lead_type:LEAD_TYPE.AGENT_WEB,
                insurer_branch_id: insurerBranchId
                
            };
            delete payload.bm_id;
            // delete params for policy holder case
            if(requestData.policy_holder === POLICY_HOLDER.COMPANY){
               // payload.npwp_no = data.ktp_id;
                delete payload.ktp_id
                delete payload.marital_status
                delete payload.gender
                delete payload.dob
                delete payload.city_birth
            }

            // validate TSI of 10%
            const carFmv = Number(requestData.car_fmv || 0);
          
            const isTenPercent = (value: number) => {
                const tenPercent = carFmv * 0.10;
                return value <= tenPercent;
            };
            if(requestData.acc_price && !isTenPercent(requestData.acc_price) && requestData?.is_acc === IS_ACC_TOGGLE.ACTIVE) {
                 draftSubmittedRef.current = false;
                 return toast.error(translations?.CREATE_APP?.ACC_PRICE_ERR) 
            }
            
            if (leadId) {
                payload.lead_id = leadId
            }
            if (payload?.old_plate_area) {
                delete payload?.old_plate_area
            }
            if (payload?.insurance_type) {
                const multi_year = (payload?.insurance_type || []).map((item: number) => ({ insurance_type: item }));
                payload.multi_year = multi_year
                delete payload?.insurance_type
            }
            payload.per_postal_code = payload.per_postal_code;
            payload.cur_postal_code = payload.cur_postal_code;

            setCreateloading(true);
            let result:any = await InsuranceService.createAgencyLeadID(payload)
            if(result?.data?.status!==200)  {
                setCreateloading(false);
                draftSubmittedRef.current = false;
                return toast.error(result?.data?.message);
            }

            const updatedImgaeState = {...imageUploadState}

            setImageUploadState(updatedImgaeState)
            setCreateloading(false);
            result = result?.data?.data;

            let lead_id = result?.leadId;
            setLeadId(lead_id);
            const docUrls: any[] = [];

            for (const doc of documentFormObj) {
                await uploadAllNodes(doc, lead_id, docUrls,updatedImgaeState);
            }
            updatedImgaeState.uploaded = docUrls?.length ?  1: 0 
            updatedImgaeState.total = docUrls?.length
            updatedImgaeState.show = updatedImgaeState?.total>0 ? true :false
            
            if (!isEdit && !docUrls?.length) {
                draftSubmittedRef.current = false;
                return toast.error(translations?.CREATE_APP?.ONE_DOC_REQUIRED)
            }

            if (docUrls?.length) {
                const requestPayload = {
                    lead_id: lead_id,
                    doc_path: docUrls,
                    is_resubmit: true,
                    created_by: user_data?.id,
                    created_by_name: user_data?.name
                };
                await addDocumentWeb(requestPayload);
            }

            // delete image for Edit case
            
            if (isEdit && deletedDocs.length) {

                await updateDocumentStatus({
                    lead_id: leadId,
                    documents: deletedDocs,
                });
            }
            setShowThankyouPopup(true)
            updatedImgaeState.show = false
            setImageUploadState(updatedImgaeState) 
        }catch(error){
        console.error(error);
        draftSubmittedRef.current = false;
        toast.error("Something went wrong");
        }finally {
        setCreateloading(false);
    }
    }
    }


    /* ---------------- Docs draft save ---------------- */
    // every uploaded file of the Docs tree with its document id
    const collectDocFiles = (nodes: any[] = [], out: any[] = []) => {
        for (const node of nodes || []) {
            (node?.uploaded_files || []).forEach((file: any, index: number) => out.push({ node, file, index }));
            if (node?.child?.length) collectDocFiles(node.child, out);
        }
        return out;
    };
    // sync fingerprint of the Docs files (a File has no url yet)
    const docFilesKey = (nodes: any[]) => collectDocFiles(nodes).map(({ node, file }) =>
        `${node?.value}:${file instanceof File ? `file:${file.name}:${file.size}` : (file?.url || file?.src || '')}`);

    const buildDraftKey = () => {
        const docData: any = getSectionFields(CREATE_PAGE_INDEX.DOC) || {};
        const payload = buildDocsDraftPayload({ requestData, docData, leadId, user: user_data });
        return { docData, payload, key: JSON.stringify({ payload, files: docFilesKey(documentFormObj) }) };
    };

    // upload not yet uploaded files so the draft can keep them (same upload as the final submit)
    const uploadDraftFiles = async () => {
        const entries = collectDocFiles(documentFormObj);
        const draftDocuments: any[] = [];
        const replaced = new Map<any, any>();
        for (const { node, file } of entries) {
            if (file instanceof File) {
                try {
                    const formData: any = new FormData();
                    formData.append('upload_type', UPLOAD_TYPE);
                    formData.append('lead_id', leadId);
                    formData.append('images', file);
                    const response: any = await docs_upload(formData);
                    const uploaded = response?.data?.[0];
                    if (!uploaded?.file_url) continue;
                    const stored = { name: file.name, src: uploaded.file_url, url: uploaded.file_url, preview_src: URL.createObjectURL(file), uploaded_immediately: true };
                    replaced.set(file, stored);
                    draftDocuments.push({ document_id: node.value, url: uploaded.file_url });
                } catch (error) {
                    console.error('Draft file upload failed', error);
                }
            } else if (file?.uploaded_immediately && (file?.url || file?.src)) {
                draftDocuments.push({ document_id: node.value, url: file.url || file.src });
            }
        }
        if (replaced.size) {
            // swap uploaded File objects so they are not uploaded again
            const swap = (nodes: any[] = []): any[] => nodes.map((node: any) => ({
                ...node,
                ...(node?.uploaded_files && { uploaded_files: node.uploaded_files.map((f: any) => replaced.get(f) || f) }),
                ...(node?.child?.length && { child: swap(node.child) }),
            }));
            setDocumentFormObj((prev: any) => swap(prev));
        }
        return draftDocuments;
    };

    const saveDocsDraft = async () => {
        clearTimeout(draftTimerRef.current);
        if (!leadId || draftSubmittedRef.current) return;
        // only after Docs were prefilled (baseline) or the agent changed something
        if (!docsBaselineRef.current && !draftDirtyRef.current) return;
        // only while the lead is still at Quotation Shared (1/1) and docs are loaded
        if (!documentFormObj?.length || !isQuotationSharedLead(leadDetailData) || isDocSectionCompleted()) return;
        if (busyRef.current) {
            // prefill / upload still running, retry later
            draftTimerRef.current = setTimeout(() => saveDraftRef.current?.(), DRAFT_AUTOSAVE_DELAY);
            return;
        }

        const { docData, payload, key } = buildDraftKey();
        draftDirtyRef.current = false;
        if (key === lastDraftRef.current) return; // nothing changed since prefill / last save
        lastDraftRef.current = key;

        // keep the cached lead detail in sync right away, it is used to refill Docs when coming back to the step
        const docFieldNames = mergeFieldObject().map((field: any) => field?.name).filter(Boolean);
        setLeadDetailData((prev: any) => {
            if (!prev || !Object.keys(prev).length) return prev;
            const updated = { ...prev };
            docFieldNames.forEach((name: string) => { updated[name] = docData?.[name] ?? null; });
            ['customer_discount', 'customer_discount_per', 'insurer_id', 'partner_id'].forEach((name) => {
                if (payload?.[name] !== undefined) updated[name] = payload[name];
            });
            return updated;
        });

        try {
            payload.draft_documents = await uploadDraftFiles();
            const result: any = await InsuranceService.createAgencyLeadID(payload);
            if (result?.data?.status !== 200) {
                lastDraftRef.current = '';
                console.error('Draft save failed', result?.data?.message);
            }
        } catch (error) {
            console.error('Draft save failed', error);
            lastDraftRef.current = '';
        }
    };
    saveDraftRef.current = saveDocsDraft;
    busyRef.current = loading || createloading || isWaitingForDocumentRead;

    // user interaction on Docs marks the draft dirty
    const markDocsDirty = () => {
        if (leadId && !draftSubmittedRef.current) draftDirtyRef.current = true;
    };

    // autosave while on Docs (covers tab close / refresh)
    useEffect(() => {
        // right after the Docs prefill: remember it as the saved state (nothing to save yet)
        if (docsBaselinePendingRef.current && !busyRef.current && documentFormObj?.length) {
            docsBaselinePendingRef.current = false;
            docsBaselineRef.current = true;
            lastDraftRef.current = buildDraftKey().key;
            return;
        }
        if (!isDocsStep(subRoute) || (!docsBaselineRef.current && !draftDirtyRef.current)) return;
        clearTimeout(draftTimerRef.current);
        draftTimerRef.current = setTimeout(() => saveDraftRef.current?.(), DRAFT_AUTOSAVE_DELAY);
        return () => clearTimeout(draftTimerRef.current);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [documentFormObj, requestData, subRoute, loading, createloading]);

    // leaving the Docs step (left panel / back) -> save immediately
    useEffect(() => {
        if (isDocsStep(prevSubRouteRef.current) && !isDocsStep(subRoute)) {
            saveDraftRef.current?.();
        }
        prevSubRouteRef.current = subRoute;
    }, [subRoute]);

    // leaving the page (dashboard, other menu) -> save immediately
    useEffect(() => {
        return () => {
            saveDraftRef.current?.();
        };
    }, []);


    const getLeadDetailData = async (params: any) => {
        
        let LeadData = leadDetailData; 
        if(Object.keys(LeadData).length === 0)  {
            setLoading(true);
           const res: any = await dispatch(getInsuranceDetail({ apptype: APP_TYPE_AGENCY, ...params }));
            if(Object.keys(res || {}).length){
                LeadData = normalizeLeadInsuranceTypes(getLeadDetailsPayload(res));
                // multi-year lead: addons come once per tenure year -> keep each addon once
                LeadData = { ...LeadData, addon_detail: uniqueAddonDetail(LeadData?.addon_detail) };
                setLeadDetailData(LeadData);
            }
            setLoading(false);
            
        }
        if(page ===1){
        fillAddons(LeadData);
        }
        
        fillForm(LeadData);
    }

    const fillForm = async (data: any) => {
        
        setIsEdit(true);
        const insuranceTypeValues = getInsuranceTypeValues(data);
        if(page===CREATE_PAGE_INDEX.CREATE+1){
            const updatedSectionList = structuredClone(sectionList)
            const createFields = updatedSectionList[CREATE_PAGE_INDEX.CREATE]?.blocks?.[0]?.fields || [];
            const bmFieldIndex = createFields.findIndex((field: any) => field.name === "bm_id");
            const agentFieldIndex = createFields.findIndex((field: any) => field.name === "lead_on_behalf_user_id");

            if (bmFieldIndex > -1 && (data?.bm_id !== undefined && data?.bm_id !== null)) {
                const bmOptions = createFields[bmFieldIndex]?.dynamicOptions || createFields[bmFieldIndex]?.options || [];
                updatedSectionList[CREATE_PAGE_INDEX.CREATE].blocks[0].fields[bmFieldIndex].value =
                    bmOptions.find((item: any) => +item?.value === +data?.bm_id) || {
                        label: data?.bm_name || "",
                        value: data?.bm_id,
                    };
            }

            if (agentFieldIndex > -1 && (data?.bm_id !== undefined && data?.bm_id !== null)) {
                const agents = (await fetchAgent({
                    role_id: ROLE.BM,
                    user_id: data?.bm_id,
                }))?.filter((item: any) => item?.role_id === ROLE.AGENT);

                updatedSectionList[CREATE_PAGE_INDEX.CREATE].blocks[0].fields[agentFieldIndex].dynamicOptions = agents;
                if (data?.agent_id !== undefined && data?.agent_id !== null) {
                    updatedSectionList[CREATE_PAGE_INDEX.CREATE].blocks[0].fields[agentFieldIndex].value =
                        agents.find((item: any) => +item?.value === +data?.agent_id) || {
                            label: data?.agent_name || "",
                            value: data?.agent_id,
                        };
                }
            }
            for(let i = 0; i < updatedSectionList[CREATE_PAGE_INDEX.CREATE]?.blocks?.[0]?.fields.length; i++){
                const field = updatedSectionList[CREATE_PAGE_INDEX.CREATE]?.blocks?.[0]?.fields[i];
                if(field.name === 'bm_id' && (data?.bm_id !== undefined && data?.bm_id !== null)){
                    const options = field?.dynamicOptions || field?.options || [];
                    updatedSectionList[CREATE_PAGE_INDEX.CREATE].blocks[0].fields[i].value =
                        options.find((item: any) => +item?.value === +data?.bm_id) || {
                            label: data?.bm_name || "",
                            value: data?.bm_id,
                        }
                }
                else if(field.name === 'lead_on_behalf_user_id' && (data?.agent_id !== undefined && data?.agent_id !== null)){
                    const options = field?.dynamicOptions || field?.options || [];
                    updatedSectionList[CREATE_PAGE_INDEX.CREATE].blocks[0].fields[i].value =
                        options.find((item: any) => +item?.value === +data?.agent_id) || {
                            label: data?.agent_name || "",
                            value: data?.agent_id,
                        }
                }
                else if(data[field.name] !== undefined && data[field.name] !== null){
                    if(field.name === 'total_fmv'){
                        data[field.name] = HELPER.addCurrencyFormatting(data[field.name])
                    }
                    updatedSectionList[CREATE_PAGE_INDEX.CREATE].blocks[0].fields[i].value = data[field.name]
                }
                else if(field.name==='bstk_age' && data?.bstk_insurer_date){  
                    updatedSectionList[CREATE_PAGE_INDEX.CREATE].blocks[0].fields[i].value = HELPER.getDayDiffFromToday(new Date(data?.bstk_insurer_date))
                }
                else if(data?.make && data?.model && data?.version){
                    const mmv ={
                        make_id: {
                            label: data?.make_name,
                            value: data?.make
                        },
                        model_id: {
                            label: data?.parent_model_name,
                            value: data?.parent_model_id
                        },
                        version_id: {
                            label: data?.version_name,
                            value: data?.version,
                            model:data?.model,
                            model_name:data?.model_name
                        },
                    }
                    if(field.name==='vehicle'){
                        const vehicle = `${data?.make_name} ${data?.parent_model_name} ${data?.version_name}`
                        updatedSectionList[CREATE_PAGE_INDEX.CREATE].blocks[0].fields[i].value = vehicle
                    }
                    dispatch(setNewMMVlist(mmv))
                }
            }
            setSectionList(updatedSectionList)
            let fields = getSectionFields(CREATE_PAGE_INDEX.CREATE,updatedSectionList);
            fields.make = data?.make;
            fields.make_name = data?.make_name;
            fields.parent_model_id = data?.parent_model_id;
            fields.parent_model_name = data?.parent_model_name;
            fields.model = data?.model;
            fields.model_name = data?.model_name;
            fields.version = data?.version;
            fields.version_name = data?.version_name;
            fields.user_id = user_data?.id;
            fields.role_id= user_data?.role_id;
            fields.rule_engine = getEffectiveRuleEngine(fields.rule_engine);
            fields.insurer_id = data.insurer_id;
            fields.partner_id = data.partner_id;
            fields.share_insurer_ids = data?.share_insurer_ids;
            fields.is_shared = QUOTATION_SHARE_TYPE.QUOTATION_SHARE_NOT
            fields.addon_detail = data?.addon_detail;
            fields.old_plate_area = data?.plate_area;
            fields.customer_discount = data?.customer_discount;
            fields.customer_discount_per = data?.customer_discount_per;
            // prefill the Quote discount inputs with the saved discount (else Quote resets it to 0)
            const savedDiscount = getSavedDiscount(data);
            if (savedDiscount) {
                setDiscountType({ value: savedDiscount.type });
                setCustomerDiscount(String(savedDiscount.value));
                fields.discount_type = savedDiscount.type;
            }
            fields.old_insurer_id = data?.insurer_id;
            if(insuranceTypeValues?.length){
                fields.insurance_type = insuranceTypeValues;
                setInsuranceValues(insuranceTypeValues);
            }
            setRequestData(fields);
            fetchInsurerList(data.addon_detail,fields)
            
        }
        if (page === 5) {
           // for document section loader
            if(subRoute === 'docs'|| subRoute === 'documents'){
            setCreateloading(true);
           }
            let updatedSectionItem = structuredClone(documentFormObj);
            if(requestData?.vehicle_condition && requestData?.policy_holder){
                const res = await leadDocList()
                updatedSectionItem = structuredClone(res?.data?.document_list)
            }
            docListReqRef.current++; // prefill wins over any doc-list call still in flight
            const numberFields = ['per_province','per_district','per_city','cur_province','cur_district','cur_city'];

            for (let i = 0; i < updatedSectionItem.length; i++) {
                const docFields = updatedSectionItem[i]?.fields || [];
                for (let j = 0; j < docFields.length; j++) {
                    const field = docFields[j];
                    if (data.hasOwnProperty(field.name)) {
                        if (numberFields.includes(field.name)) {
                            field.value = Number(data[field.name]);
                            if (field.name === 'cur_city' || field.name === 'per_city') {
                              const prefix = field.name.split("_")[0];
                              const provinceId = Number(data[`${prefix}_province`]);
                              if (provinceId) {
                                const res:any = await dispatch(getCityList({ state: [provinceId] }));
                                const cityOptions = res?.data?.map((city: any) => ({
                                    label: city.label || city.value,
                                    value: +(Number.isFinite(Number(city?.value)) ? city.value : city?.id),
                                })) || [];

                                field.options = cityOptions
                                field.dynamicOptions = cityOptions
                              }
                            }
                            if (field.name === 'cur_district' || field.name === 'per_district') {
                              const prefix = field.name.split("_")[0];
                              const cityId = Number(data[`${prefix}_city`]);
                             // setLoading(true);
                              const res:any = await fetchPermanentLocality({cityId, prefix,dispatch})
                             // setLoading(false);

                              field.options  = res?.districtOptions
                              field.dynamicOptions = res?.districtOptions          
                            }
                        }                           
                        else if (field.name === "per_sameas_cur") {


                            field.value = data[field.name] === SAME_AS_KTP ? SAME_AS_KTP : false

                            // disabled during edit
                            if (data?.per_sameas_cur === SAME_AS_KTP) {
                                docFields.forEach((f: any) => {
                                    if (['cur_house_no', 'cur_rt', 'cur_rw', 'cur_province', 'cur_district', 'cur_city','cur_sub_district'].includes(f.name)) {
                                        f.is_enable = false;
                                    }
                                });
                            }
                        }
                        else if (field.name === 'plate_number' && requestData?.old_plate_area !== requestData?.plate_area) {
                            const plateValue = String(data[field.name] || '').trim().toUpperCase();
                            const plateParts = plateValue.split(/\s+/).filter(Boolean);
                            const plateSuffix = plateParts.slice(1).join(' ');
                            const plateAreaList = commonState?.common?.plate_area || [];
                            const plateAreaLabel = plateAreaList.find((row: any) => String(row.value) === String(requestData?.plate_area))?.label || (typeof requestData?.plate_area === 'string' ? requestData.plate_area : '');
                            const platePrefix = String(plateAreaLabel).split('-')[0].trim().toUpperCase();
                            field.value = platePrefix ? (plateSuffix ? `${platePrefix} ${plateSuffix}` : platePrefix) : plateValue;
                        }
                        else if (field.name === 'plate_number') {
                            field.value = formatOcrPlateNumber(data[field.name]);
                        }
                         else {
                            field.value = data[field.name];
                        }
                    }
                }
            }

            //  IMAGE PREFILL 
            const apiDocs = data?.documents || [];
                

            apiDocs.forEach((doc: any) => {
                // draft docs (saved before submit) are re-sent on submit like freshly uploaded files
                const files = (doc.path || []).map((p: any) => doc?.is_draft
                    ? { src: p.src, url: p.url || p.src, uploaded_immediately: true }
                    : { id: p.id, src: p.src });
                updatedSectionItem.forEach((item: any) => {
                    // match parent
                    if (item.value === doc.id) {
                        item.uploaded_files = files;
                        return;
                    }
                    // recursive child match (FIX)
                    if (item.child?.length) {
                        attachFilesRecursively(item.child, doc.id, files);
                    }
                });
            });

            setDocumentFormObj(updatedSectionItem);
            docsBaselinePendingRef.current = true; // autosave compares against this prefilled state
            if (subRoute === 'docs' || subRoute === 'documents') {
                setCreateloading(false);
            }
        }   
        setPage(5)
        
    }

    const fillAddons = async (data: any) => {
        setLoading(true);
        let addons = await fetchAddons(data);
        setLoading(false);
        const updatedAddonState = structuredClone(addonState)
        addons = [...addons?.basic,...addons?.special];


        for(let i = 0; i < data?.addon_detail?.length; i++){
            const addon = addons?.find((row:any)=>row?.id===data?.addon_detail[i]?.id);
            const actualAddonData = data?.addon_detail?.find((row:any)=>row?.id===addon?.id);
            if(actualAddonData?.id===addon?.id){
            
                updatedAddonState[actualAddonData?.id] = {
                    checked:true,
                    premium: actualAddonData?.premium_amount
                }
                if(addon?.coverage_list){
                    updatedAddonState[actualAddonData?.id].coverage = {
                        value: actualAddonData?.coverage_amount,
                        label: HELPER.addCurrencyFormatting(actualAddonData?.coverage_amount)
                    }
                }
                if(addon?.default_passenger){
                    updatedAddonState[actualAddonData?.id].passengers = {
                        label: actualAddonData?.seat_capacity,
                        value: actualAddonData?.seat_capacity
                    }
                }
            }
            
        }
        setAddonState(updatedAddonState)
    }
    
    
    useEffect(() => {
        if(leadId){
            if(requestData?.is_shared !== QUOTATION_SHARE_TYPE.QUOTATION_SHARE){
                getLeadDetailData({leadId})
            }
        }
    },[leadId,searchParams])

    // Continue Application: the first fill (page 1) prefills Application/Add-ons/Quote and moves page to 5;
    // search params don't change after that, so trigger the Docs prefill once here.
    // Continue Application resumes where the lead is:
    // quotation shared with multiple insurers and no final quote / docs data yet -> Quote step,
    // otherwise (single insurer chosen or docs already filled) -> Docs step.
    useEffect(() => {
        if (continueToDocsRef.current && leadId && page === 5) {
            continueToDocsRef.current = false;
            if (shouldResumeAtQuote(leadDetailData)) {
                setSearchParams({ step: 'quote' });
                return;
            }
            getLeadDetailData({ leadId });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, leadId])

    // Docs section is complete only once documents were actually submitted (lead moved past Quotation Shared)
    const isDocSectionCompleted = () =>
        (+leadDetailData?.sub_status_id || 0) >= LEAD_STATUS.submitted.sub_status_id ||
        (leadDetailData?.documents || []).some((doc: any) => !doc?.is_draft && doc?.path?.length);
    const isSectionCompleted = (index: number) =>
        (index + 1) < page && (index !== CREATE_PAGE_INDEX.DOC || isDocSectionCompleted());


    useEffect(() => {
        if ((commonIdState?.state).length === 0) {
            dispatch(getStateList())
        }
         if ((commonIdState?.city).length === 0) {
            dispatch(getCityList({ state: [] }))
        }
        // eslint-disable-next-line
    }, []);


   // instant call for upload image
   const uploadDocumentNow = async (file: File, docId?: number | string) => {
    const formData: any = new FormData();
    formData.append('upload_type', UPLOAD_TYPE);
    formData.append('lead_id', 'insurance_id_orcr');
    formData.append('images', file);

    setLoading(true);
    try {
        const response: any = await docs_upload(formData);
        const uploadedFile = response?.data?.[0];
        const resolvedDocId = Number(docId) || docId;
        const shouldReadDocument = [OCR_NPWP_ID, OCR_KTP_ID, OCR_STNK_ID].includes(Number(resolvedDocId));

        if (!uploadedFile?.file_url) {
            throw new Error('Document upload failed');
        }

        if (docId && shouldReadDocument) {
            try {
                setCreateloading(true);
                setIsWaitingForDocumentRead(true);
                const readDocumentRes: any = await dispatch(uploadAndReadDocument({
                    user_id: user_data?.id,
                    source: 'web',
                    documents: [
                        {
                            file_url: uploadedFile?.signed_url || uploadedFile.file_url,
                            file_size: uploadedFile?.file_size || file?.size || '',
                            doc_id: resolvedDocId,
                        },
                    ],
                }));
               
                const readDocumentData = readDocumentRes?.data || readDocumentRes || {};
                
                // match plate area 
                const selectedPlateAreaPrefix = commonState?.common?.plate_area?.find((row: any) => row?.value === requestData?.plate_area)?.label?.match(/^[A-Za-z]+/)?.[0]?.trim()?.toUpperCase() || "";
                const detectedPlateAreaPrefix = readDocumentData?.plate_number?.match(/^[A-Za-z]+/)?.[0]?.trim()?.toUpperCase() || "";
                
                const isPlateAreaMatched =  (resolvedDocId === OCR_STNK_ID && selectedPlateAreaPrefix === detectedPlateAreaPrefix );

                if (resolvedDocId === OCR_STNK_ID && !isPlateAreaMatched) {
                    toast.error(translations?.OCR_PLATE_ERR);
                }

                let preFill_field:any = {

                    // NPWP details
                    npwp_no: (resolvedDocId === OCR_NPWP_ID) &&(readDocumentData?.npwp_number || readDocumentData?.npwp_no || "") ,
                    name : ((resolvedDocId === OCR_NPWP_ID) && (readDocumentData?.name || readDocumentData?.company_name || "") ),
                   
                    // KTP details
                    ktp_id:  (resolvedDocId === OCR_KTP_ID) && readDocumentData?.ktp_id  || "",
                    marital_status : (resolvedDocId === OCR_KTP_ID) && commonState?.common?.marital_status?.find((val:any)=> val?.label?.toLowerCase() === readDocumentData?.marital_status?.toLowerCase())?.value || "",
                    gender :   (resolvedDocId === OCR_KTP_ID) && commonState?.common?.gender.find((val:any) => val?.label?.toLowerCase() === readDocumentData?.gender?.toLowerCase())?.value  || "",
                    dob: (resolvedDocId === OCR_KTP_ID) && readDocumentData?.dob || "",
                    per_house_no : (resolvedDocId === OCR_KTP_ID) && readDocumentData?.housing || "",
                    per_province: (resolvedDocId === OCR_KTP_ID) && readDocumentData?.province || "",
                    per_city: (resolvedDocId === OCR_KTP_ID) && readDocumentData?.city || "",
                    per_sub_district: (resolvedDocId === OCR_KTP_ID) && readDocumentData?.sub_district || "",           
                    per_district: (resolvedDocId === OCR_KTP_ID) && readDocumentData?.district || "",
                   
                    //STNK details
                    machine_number: (resolvedDocId === OCR_STNK_ID) && readDocumentData?.machine_number  || "",
                    chassis_number: (resolvedDocId === OCR_STNK_ID) && readDocumentData?.chassis_number || "",
                    color: (resolvedDocId === OCR_STNK_ID) && readDocumentData?.color || "",
                    plate_number: (resolvedDocId === OCR_STNK_ID && isPlateAreaMatched) && formatOcrPlateNumber(readDocumentData?.plate_number) || ""
                   
                    //  ...(readDocumentData?.city && { per_district: commonIdState?.district?.filter((val: any) => val.city_id === readDocumentData?.city)})
                }
                setCreateloading(false);
                return {
                    name: file.name,
                    src: uploadedFile.file_url,
                    url: uploadedFile.file_url,
                    preview_src: URL.createObjectURL(file),
                    uploaded_immediately: true,
                    prefill_fields: preFill_field,
                }
            } catch (err) {
                 setCreateloading(false);
                console.error(err);
            } finally {
                setIsWaitingForDocumentRead(false);
            }
        }
         setCreateloading(false);
        return {
            name: file.name,
            src: uploadedFile.file_url,
            url: uploadedFile.file_url,
            preview_src: URL.createObjectURL(file),
            uploaded_immediately: true,
        };
    } catch (error) {
        console.error(error);
        toast.error('Document upload failed');
        throw error;
    } finally {
        setLoading(false);
        setImageUploadState((prev: any) => ({ ...prev, show: false }));
    }
   };

   const uploadDocumentFiles = async (doc: any, lead_id: number, docUrls: any[],updatedImgaeState?:any) => {
    const files = doc.uploaded_files || [];
    //let count = 0;

    // Upload top-level document files
    for (const file of files) {
        if (file instanceof File) {
        const formData: any = new FormData();
        formData.append('upload_type', UPLOAD_TYPE);
        formData.append('lead_id', lead_id);
        formData.append('images', file);

        const response: any = await docs_upload(formData);
        const uploadedFile = response.data[0];

        const obj:Record<string,any> ={
                url: uploadedFile.file_url,
                document_id: doc.value,
        }
        if(doc?.comment)obj.comment = doc.comment
        docUrls.push(obj);
        //count++;
        if(updatedImgaeState){
            setImageUploadState((prev: any) => ({
                ...prev,
                uploaded: prev.uploaded + 1
            }));
        }
        } else if (file?.uploaded_immediately && (file?.url || file?.src)) {
        const obj: Record<string, any> = {
                url: file.url || file.src,
                document_id: doc.value,
        };
        if (doc?.comment) obj.comment = doc.comment;
        docUrls.push(obj);
        }
        
    }

    // Recursive upload only if child array exists
    if (doc.child?.length) {
        for (const child of doc.child) {
        await uploadDocumentFiles(child, lead_id, docUrls, updatedImgaeState);
        }
    }
    };

   const showAgentNameField = async (updatedList: any) => {

     const updatedSectionList = updatedList;
     const createFields =
       updatedSectionList[CREATE_PAGE_INDEX.CREATE]?.blocks?.[0]?.fields || [];

     const bmFieldIndex = createFields.findIndex((field: any) => field.name === "bm_id");
     const agentFieldIndex = createFields.findIndex(
       (field: any) => field.name === "lead_on_behalf_user_id"
     );

     if (bmFieldIndex === -1 || agentFieldIndex === -1) {
       return updatedSectionList;
     }

     updatedSectionList[CREATE_PAGE_INDEX.CREATE].blocks[0].fields[bmFieldIndex] = {
       ...createFields[bmFieldIndex],
       is_show: false,
       options: [],
       dynamicOptions: [],
       child_depedencies: ["lead_on_behalf_user_id"],
     };

     updatedSectionList[CREATE_PAGE_INDEX.CREATE].blocks[0].fields[agentFieldIndex] = {
       ...createFields[agentFieldIndex],
       is_show: false,
       options: [],
       dynamicOptions: [],
       parent_depedencies: null,
     };

     if (user_data?.role_id == ROLE.BM) {
       const agents = (await fetchAgent({
         role_id: user_data?.role_id,
         user_id: user_data?.id,
       }))?.filter((item: any) => item?.role_id === ROLE.AGENT);

       updatedSectionList[CREATE_PAGE_INDEX.CREATE].blocks[0].fields[agentFieldIndex] = {
         ...updatedSectionList[CREATE_PAGE_INDEX.CREATE].blocks[0].fields[agentFieldIndex],
         is_show: true,
         dynamicOptions: agents,
       };
     }

     if (user_data?.role_id == ROLE.AM) {
       const bms = (await fetchAgent({
         role_id: user_data?.role_id,
         user_id: user_data?.id,
       }))?.filter((item: any) => item?.role_id === ROLE.BM);

       updatedSectionList[CREATE_PAGE_INDEX.CREATE].blocks[0].fields[bmFieldIndex] = {
         ...updatedSectionList[CREATE_PAGE_INDEX.CREATE].blocks[0].fields[bmFieldIndex],
         is_show: true,
         dynamicOptions: bms,
       };

       updatedSectionList[CREATE_PAGE_INDEX.CREATE].blocks[0].fields[agentFieldIndex] = {
         ...updatedSectionList[CREATE_PAGE_INDEX.CREATE].blocks[0].fields[agentFieldIndex],
         is_show: true,
         parent_depedencies: "bm_id",
       };
     }
     return updatedSectionList;
   };
   const fetchAgent = async (params: any) => {
     setLoading(true);
     let res = await dispatch(getReporteeID(params));
     res = Array.isArray(res) ? res.map((row: any) => {
       return {
         label: row?.name,
         value: row?.id,
         role_id: row?.sfa_role_id,
       };
     }) : [];

     setLoading(false);
     return res;
   };

   const attachFilesRecursively = (nodes: any[], docId: number, files: any) => {
                for (const node of nodes) {
                    if (node.value === docId) {
                        node.uploaded_files = files;
                        return true;
                    }
                    if (node.child?.length) {
                        const found = attachFilesRecursively(node.child, docId, files);
                        if (found) return true;
                    }
                }
                return false;
            };

    const countFiles = (node: any): number => {
        let total = (node.uploaded_files || []).filter((file: any) => file instanceof File).length;
        if (node.child?.length) {
            total += node.child.reduce((sum: number, c: any) => sum + countFiles(c), 0);
        }
        return total;
    };

    return (
        <React.Fragment>
            <FullPageLoader show={ createloading || loading} />
            {
                subRoute=='resubmission' && (

                <div className="documents-resubmission">
                        <DocumentResubmission 
                        documentList={documentList} 
                        resubmissionLeadId={resubmissionLeadId} 
                        setDocumentList={setDocumentList}
                        uploadDocumentFiles={uploadDocumentFiles}  
                        addDocumentWeb={addDocumentWeb}
                        setLoading={setLoading}
                        updateDocumentStatus={updateDocumentStatus}
                        isShowResubmitBtn={isShowResubmitBtn}
                        />
                    </div>
                )
                            
                
            }
            {
                subRoute!=='resubmission' && (
                    <div className="container-fluid add-insurnce-outer">
                        <div className="top-heading financer-lead-heding">
                            <h1> { isEdit ? translations?.CREATE_APP?.EDIT_INS_APP :translations?.CREATE_APP?.ADD_INS_APP} </h1> 
                        </div>
                        <div className="lead-detail-tabs">
                            {
                                sectionList && <div className="detail-form-sec">
                                    <div className="menu-tab-left-panel">
                                        <div className="dealer-tab-left-panel nav">
                                            <ul>
                                                {
                                                    sectionList.map((sectionItem: any, index: any) => {
                                                        return (
                                                            <li key={index}>
                                                                {
                                                                    ((page > index)) ?
                                                                        <NavLink to={`/create-insurance-policy${resubmissionLeadId ? ('/' + resubmissionLeadId) : ''}?step=` + sectionItem['key']} onClick={(e) => { handleNavLinkRouting(sectionItem['title']) }} className={isSectionCompleted(index) ? "completed" : ""}   >
                                                                            <span className="img-type">
                                                                                {isMobile && (index+1) }
                                                                            </span>
                                                                           <span  className='nav-tittle'> {sectionItem['title']}
                                                                            </span>
                                                                            
                                                                           </NavLink>
                                                                        :
                                                                        <a href="#!" onClick={(e) => {}} >
                                                                            <span className="img-type">
                                                                                {isMobile && (index+1) }
                                                                            </span>
                                                                           <span className='nav-tittle'> {sectionItem['title']}</span>
                                                                        </a>

                                                                }
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="route-files">
                                        <div className=" insurance-create-outer relative " style={{ "display": "block" }}>
                                            <div className="loan-expect-left-panle create-lead-main">
                                                <div className="loan-form">
                                                    <div className={`loan-form-filed-scroll ${(searchParams?.get('step') === 'upload_document') ? `quote-scroll` : ''}`}>
                                                        {
                                                            subRoute === 'vehicle' && <Create 
                                                            sectionItem={sectionList} 
                                                            setSectionItem={setSectionList} 
                                                            handleSubmit={handleSubmit} 
                                                            setLoading={setLoading} isEdit={isEdit} loading={loading}
                                                            setAddonState={setAddonState}
                                                            requestData={requestData}
                                                            setRequestData={setRequestData}
                                                            insuranceValues = {insuranceValues}
                                                            setInsuranceValues = {setInsuranceValues}

                                                            />
                                                        }
                                                        {
                                                            // send key with rule engine or without rule engine
                                                            subRoute === 'addons' && 
                                                            <Addons
                                                            
                                                                getSectionFields={getSectionFields}
                                                                basicAddons={basicAddons}
                                                                specialAddons={specialAddons}
                                                                addOnQuesAns={addOnQuesAns}
                                                                onSubmitAddons={handleSubmit}
                                                                handleSkip={handleSkip}
                                                                addonState={addonState}
                                                                setAddonState={setAddonState}
                                                                error={addonError}
                                                                setError={setAddonError}
                                                                sectionList={sectionList}
                                                                fetchAddons={fetchAddons}
                                                                isEdit = {isEdit}
                                                                
                                                            />
                                                        }
                                                        {
                                                            subRoute === 'quote' && !isMobile &&
                                                            <Quotes 
                                                            addonState={addonState} 
                                                            setAddonState={setAddonState}
                                                            requestData={requestData} 
                                                            setRequestData={setRequestData} 
                                                            fetchInsurerList={fetchInsurerList}
                                                            handleSubmit={handleSubmit}
                                                            discountType={discountType}
                                                            setDiscountType={setDiscountType}
                                                            customerDiscount={customerDiscount}
                                                            setCustomerDiscount={setCustomerDiscount}  
                                                            error={addonError}
                                                            setError={setAddonError}
                                                            fetchAddons={fetchAddons}
                                                            leadId={leadId}
                                                            setLeadId={setLeadId}
                                                    
                                                            />

                                                        }

                                                          {
                                                            subRoute === 'quote' && isMobile &&
                                                            <QuotesMobile 
                                                            addonState={addonState} 
                                                            setAddonState={setAddonState}
                                                            requestData={requestData} 
                                                            setRequestData={setRequestData} 
                                                            fetchInsurerList={fetchInsurerList}
                                                            handleSubmit={handleSubmit}
                                                            discountType={discountType}
                                                            setDiscountType={setDiscountType}
                                                            customerDiscount={customerDiscount}
                                                            setCustomerDiscount={setCustomerDiscount}  
                                                            error={addonError}
                                                            setError={setAddonError}
                                                            fetchAddons={fetchAddons}
                                                            leadId={leadId}
                                                            setLeadId={setLeadId}
                                                    
                                                            />
                                                            
                                                        }

                                                        {
                                                            (subRoute === 'docs'|| subRoute === 'documents') && (
                                                                <div onChangeCapture={markDocsDirty} onInputCapture={markDocsDirty} onClickCapture={markDocsDirty} onKeyDownCapture={markDocsDirty}>
                                                                    <Docs
                                                                        documentList={documentFormObj}
                                                                        setSectionItem= {setDocumentFormObj} handleSubmit = {handleSubmit}  requestData = {requestData} setLoading = {setLoading} setDeletedDocs={setDeletedDocs}   isEdit = {isEdit}   
                                                                        loading = {loading}
                                                                        sectionList={sectionList}
                                                                        setRequestData={setRequestData}
                                                                        uploadDocumentNow={uploadDocumentNow}

                                                                    />
                                                                </div>
                                                            )
                                                        }
                                            
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                )
            }
            {
                showThankyouPopup && <AddApplicationThankPopup show={showThankyouPopup} handleClose={() => {
                    setShowThankyouPopup(false)
                    navigate(`/dashboard`)
                }} leadId={leadId} />
            }
            {
                imageUploadState?.show && 
                <UploadImagesPopup show ={imageUploadState?.show} screenType={'REGISTER'} imageUploadState={imageUploadState}/>
            }
            <WaitPopUpModal show={isWaitingForDocumentRead} handleClose={() => setIsWaitingForDocumentRead(false)} />
        </React.Fragment>
         
    )
}
